export default __webpack_public_path__ + "static/media/checkedsupplier.7962ab0d.svg";